module.exports = __webpack_public_path__ + "img/9.152f6ae5.png";